import { useState, useEffect } from "react";
import { Search, Sprout, Handshake } from "lucide-react";

const valuePropositions = [
  {
    icon: Search,
    text: "Access a pre-vetted, motivated talent pool.",
  },
  {
    icon: Sprout,
    text: "Build a diverse and loyal workforce.",
  },
  {
    icon: Handshake,
    text: "Make a tangible social impact in your community.",
  },
];

export const ValuePropositionCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % valuePropositions.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const CurrentIcon = valuePropositions[currentIndex].icon;

  return (
    <div className="relative w-full h-full flex items-center justify-center bg-gradient-to-br from-primary to-secondary p-12 rounded-2xl md:rounded-l-2xl md:rounded-r-none min-h-[300px] md:min-h-[600px]">
      <div className="text-center text-white max-w-md space-y-8 animate-fade-in">
        <div className="flex justify-center">
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-full">
            <CurrentIcon className="w-20 h-20" strokeWidth={1.5} />
          </div>
        </div>
        <p className="text-2xl font-semibold leading-relaxed">
          {valuePropositions[currentIndex].text}
        </p>
        <div className="flex justify-center gap-2 mt-6">
          {valuePropositions.map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all duration-300 ${
                index === currentIndex ? "w-8 bg-white" : "w-2 bg-white/40"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
